import { createContext, useContext } from 'react';

/** Shell-level actions any page can trigger (open the nav drawer, the shortcuts sheet). */
export const ShellContext = createContext({
  openNav: () => {},
  closeNav: () => {},
  navOpen: false,
  openShortcuts: () => {},
});

export const useShell = () => useContext(ShellContext);
